export default "__VITE_ASSET__B4idj1$0__";